define('entities/suppliers/imprint_technologies',[
  'app',
  'jquery',
  'underscore',
  'backbone',
  'settings',
  'backboneRelational',
  'entities/product_translation'
], function (
  App,
  $,
  _,
  Backbone,
  Settings
) {
  'use strict';

  /**
   * Model
   */
  var app;
  if (Backbone.Relational.store._modelScopes && Backbone.Relational.store._modelScopes.length > 0) {
    app = {ns: Backbone.Relational.store._modelScopes[0]};
  } else {
    app = {ns: {}};
    Backbone.Relational.store.addModelScope(app.ns);
  }

  app.ns.SupplierImprintTechnology = Backbone.RelationalModel.extend({
    defaults: {
      id: '',
      code: '',
      colorModeType: 'quadri',
      maxNumberOfColors: 4,
      name: new app.ns.DynamicText(),
      supplier: '',
      supplierUid: ''
    },

    url: function () {
      var supplierUid = this.get('supplierUid');
      var id = this.get('id');

      
      if (supplierUid && id) {
          return Settings.url('compuzz2', 'v2/suppliers/imprintTechnologies' + '/' + supplierUid + '/' + id);
      } else {
          return Settings.url('compuzz2', 'v2/suppliers/imprintTechnologies');
      }
    },

    save: function () {

      // Use PUT method for updates
      var options = {
        type: 'PUT'
      };
      return Backbone.Model.prototype.save.call(this, null, options);
    },

    parse: function(response) {
      // Ensure name DynamicText field is properly instantiated
      if (response.name && typeof response.name.toJSON !== 'function') {
        response.name = new app.ns.DynamicText(response.name);
      }
      return response;
    },

    idAttribute: 'secId',

    relations: [{
      type: Backbone.HasOne,
      key: 'name',
      relatedModel: 'DynamicText'
    }]
  });

  /**
   * REST API
   */
  App.reqres.setHandler('supplier-imprint-technologies:model', function (imprintTechnologyJSON) {
    var tt;
    if (imprintTechnologyJSON) {
      tt = Backbone.Relational.store.find(app.ns.SupplierImprintTechnology, imprintTechnologyJSON.secId);
    }
    if (tt) {
      return tt;
    } else {
      return new app.ns.SupplierImprintTechnology(imprintTechnologyJSON);
    }
  });

});
